import { VideoQuality } from '@zoom/videosdk';
import { useCallback, useEffect, useRef } from 'react';

function useConnectionChange({ zoomClient, endCall }) {
  const endCallRef = useRef(endCall);
  endCallRef.current = endCall;
  const userIdRef = useRef();
  const connectionChanged = useCallback(
    payload => {
      const sessionInfo = zoomClient.getSessionInfo();
      console.log('🚀 ~ useConnectionChange ~ sessionInfo:', payload, sessionInfo);
      if (payload.state === 'Connected') {
        console.log(
          '🚀 ~ useConnectionChange ~ userIdRef : => ',
          userIdRef.current,
          sessionInfo?.userId,
        );
        if (!userIdRef.current) {
          userIdRef.current = sessionInfo?.userId;
        } else if (userIdRef.current !== sessionInfo?.userId) {
          endCallRef.current();
        }
      }
      if (payload.state === 'Fail') {
        endCallRef.current();
      }
      if (payload.state === 'Closed') {
        endCallRef.current();
      }
      if (payload.state === 'Reconnecting') {
        console.log('Reconnecting');
      }
    },
    [zoomClient],
  );

  useEffect(() => {
    if (!zoomClient) return;
    zoomClient.on('connection-change', connectionChanged);
    return () => {
      zoomClient.off('connection-change', connectionChanged);
    };
  }, [connectionChanged, zoomClient]);
}

export default useConnectionChange;
